/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */

export type AlertConfigRuleDetailV9SubType =
  (typeof AlertConfigRuleDetailV9SubType)[keyof typeof AlertConfigRuleDetailV9SubType];

export const AlertConfigRuleDetailV9SubType = {
  COMPOUND: 'COMPOUND',
  CUSTOM: 'CUSTOM',
  SINGLE: 'SINGLE',
} as const;
